// import $ from "jquery";
export default function(value) {


    const backto = () => {
        return "Forside";
    }

    let bc = sessionStorage.getItem("breadcrumbs");
    
    let fromSS_bc = `
                    <li class="breadcrumb-item"><a href="/">${backto()}</a></li>
                    <li class="breadcrumb-item active" aria-current="page" id='currentPageBreadcrumb'></li>
                    `;

    if (bc) {
        fromSS_bc = bc;
    }

    return `
    
    <div class="row">
        <div class="col-sm-12">
            <div class="fullnav__breadcrumb__container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb fullnav__breadcrumb" id="full__breadcrumb">
                        ${fromSS_bc}
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    `;

}
